export const JOHN_DEERE_FIELDS_API = '/api/john-deere/organizations';
